<script>
    import constants from '../../constants';
    import { getCookie } from '../../functions';

    export default {
        props: {
            mediaType: {
                type: String,
                required: true,
            },
            videoId: {
                type: String,
                required: true,
            },
            notification: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                loaded: false,
            };
        },
        computed: {
            platform() {
                const key = Object.keys(constants.api.question.mediaTypes).find(k => constants.api.question.mediaTypes[k] === this.mediaType);
                return constants.api.question.videoPlatforms[key];
            },
            videoUrl() {
                return this.platform === constants.api.question.videoPlatforms.youtube
                    ? `https://www.youtube-nocookie.com/embed/${this.videoId}`
                    : `https://player.vimeo.com/video/${this.videoId}`;
            },
            externalLink() {
                return this.platform === constants.api.question.videoPlatforms.youtube
                    ? `https://www.youtube.com/watch?v=${this.videoId}`
                    : `https://vimeo.com/${this.videoId}`;
            },
        },
        mounted() {
            const cookieChoice = getCookie(constants.occ.name);

            if (cookieChoice === constants.occ.value) {
                this.loaded = true;

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: constants.occ.event + this.platform
                });
            }
        }
    };
</script>

<template>
    <figure v-if="loaded" class="questionnaire-embed__header-media image is-16by9 is-clipped has-radius mb-5">
        <iframe class="has-ratio"
                width="800"
                height="450"
                :src="videoUrl"
                :title="`${platform} video player`"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen></iframe>
    </figure>
    <div v-else class="notification has-background-secondary has-radius content">
        <p>{{ notification }}</p>
        <p>
            <a :href="externalLink" target="_blank" class="is-capitalized">{{ platform }} video</a>
        </p>
    </div>
</template>